// in src/Planess.js
import * as React from "react";
// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  ReferenceField,
  ReferenceInput,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  SelectInput,
  FileField,
  FileInput,
  BooleanField,
  NumberInput,
  BooleanInput,
  useNotify, useRefresh, useRedirect, 
  useCreate,
  useRecordContext,
  useCreateContext,
  useUpdate
} from "react-admin";

const PlanesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="title" alwaysOn />
  </Filter>
);

export const PlanesList = (props) => (
  <List {...props} filters={<PlanesFilter />}>
    <Datagrid>
      <TextField source="nombre" label="Nombre" />
      {/* <RichTextField source="body" /> */}
      <TextField source="lineas" label="# de Líneas" />
	  
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);
const PlanesTitle = ({ record }) => {
  return <span>Plan {record ? `${record.nombre}` : ''}</span>;
};

export const PlanesShow = (props) => (
  <Show title={<PlanesTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Identificador" />
      <TextField source="nombre" />
      <TextField source="description" label="Descripción" />

      <TextField source="precio" label="Precio" />

      <TextField source="productos" />
      <TextField source="categorias" />
      <TextField  source="lineas" />
      <TextField source="ordenes" />

      <BooleanField source="cuenta_verificada" />
      <BooleanField source="generacion_links" />
      <BooleanField source="informes_profesionales" />
      <BooleanField source="integracion_pagina" />
      
      <BooleanField source="manejo_inventario" />
      <BooleanField source="panel_admin" />
      
      <BooleanField source="soporte_web" />
    </SimpleShowLayout>
  </Show>
);

export const PlanesCreate = (props) => {
  const [create] = useCreate();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSuccess = async (fieldValues) => {
    await create('planes', { data: fieldValues }, {
      onSuccess: async (data) => {
        data.id_plan = data.id;
        await fetch(process.env.REACT_APP_CREATE_PRICES_URL, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        notify('El plan ha sido creado exitosamente');
        redirect('show', 'planes', data.id);
      },
    });
    }

  return (<Create title="Crear plan" {...props} >
    <SimpleForm onSubmit={handleSuccess}>
      <TextInput style={{width:'100%'}} source="nombre" />
      <TextInput style={{width:'100%'}} source="description" label="Descripción" />

      <NumberInput min={0} style={{width:'100%'}} source="precio" label="Precio" />

      <NumberInput style={{width:'100%'}} source="productos" />
      <NumberInput style={{width:'100%'}} source="categorias" />
      <NumberInput style={{width:'100%'}} source="lineas" />
      <NumberInput style={{width:'100%'}} source="ordenes" />

      <BooleanInput style={{width:'100%'}} source="cuenta_verificada" />
      <BooleanInput style={{width:'100%'}} source="generacion_links" />
      <BooleanInput style={{width:'100%'}} source="informes_profesionales" />
      <BooleanInput style={{width:'100%'}} source="integracion_pagina" />
      
      <BooleanInput style={{width:'100%'}} source="manejo_inventario" />
      <BooleanInput style={{width:'100%'}} source="panel_admin" />
      
      <BooleanInput style={{width:'100%'}} source="soporte_web" /> 
    </SimpleForm>
  </Create>);
};

export const PlanesEdit = (props) => {
  const [update] = useUpdate();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSuccess = async (fieldValues) => {
    await update('planes', { id: fieldValues.id, data: fieldValues }, {
      onSuccess: async (data) => {
        data.id_plan = data.id;
        await fetch(process.env.REACT_APP_CREATE_PRICES_URL, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        notify('El plan ha sido modificado exitosamente');
        redirect('show', 'planes', data.id);
      },
    });
  }

  return (<Edit title={<PlanesTitle />} {...props}>
    <SimpleForm onSubmit={handleSuccess}>
      <TextInput style={{width:'100%'}} source="nombre" />
      <TextInput style={{width:'100%'}} source="description" label="Descripción" />

      <NumberInput min={0} style={{width:'100%'}} source="precio" label="Precio" />
      <NumberInput style={{width:'100%'}} source="duracionendias" label="Días para inactivar" />

      <BooleanInput style={{width:'100%'}} source="mostrar" label="Mostrar en back" />
      
      <NumberInput style={{width:'100%'}} source="lineas" />
      <NumberInput style={{width:'100%'}} source="productos" />
      <NumberInput style={{width:'100%'}} source="categorias" />

      <NumberInput style={{width:'100%'}} label="Publicidad paga por X días" source="publicidadpaga" />

      

      <BooleanInput style={{width:'100%'}} source="panel_admin" label="Panel administración" />
      <BooleanInput style={{width:'100%'}} source="soporte_web" />
      <BooleanInput style={{width:'100%'}} source="historial_pedidos" />
      <BooleanInput style={{width:'100%'}} source="certificado_ssl" />
      <BooleanInput style={{width:'100%'}} source="notificaciones_push" />
      <BooleanInput style={{width:'100%'}} source="manejo_inventario" />
      <BooleanInput style={{width:'100%'}} source="generacion_links" />
      
    </SimpleForm>
  </Edit>
  );
};
